import { render, staticRenderFns } from "./whd_footer.vue?vue&type=template&id=67bf2830&lang=pug&"
import script from "./whd_footer.vue?vue&type=script&lang=js&"
export * from "./whd_footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports